<template>
  <Container>
    <template #header>
      <HeaderFe />
    </template>
    <template v-slot:default>
      <main class="pt-14 pb-17.5">
        <section v-if="filteredNews.length > 0">
          <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <div class="max-w-[770px] mx-auto w-full text-center mb-12.5">
              <div class="relative mb-4 text-sm text-gray-800">
                <div class="absolute top-0 bottom-0 left-0 flex items-center pl-2 text-gray-500 pointer-events-none">
                  <MagnifyingGlassVue />
                </div>
                <input v-model="search" type="text" autocomplete="off" placeholder="Cari berita..." id="search"
                  class="block w-full py-2 pl-10 text-gray-900 border-0 rounded-lg ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
              </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-y-11 gap-x-8">
              <template v-for="item in paginatedNews" :key="item.id">
                <!-- blog item -->
                <div
                  class="group shadow-lg h-full flex flex-col bg-white rounded-[10px] p-4 transition-all hover:scale-105 min-h-[400px]">
                  <div class="mb-6 overflow-hidden rounded-[10px] flex-shrink-0 relative">
                    <Link :href="`/read/${item.slug}`">
                    <!-- Single Image -->
                    <div v-if="!Array.isArray(item.image) && item.image">
                      <img :src="item.image" :alt="item.title"
                        class="object-cover w-full h-56 transition-transform duration-300 cursor-pointer hover:scale-105"
                        @click.prevent="openImageModal(item)" />
                    </div>

                    <!-- Multiple Images -->
                    <div v-else-if="Array.isArray(item.image) && item.image.length > 0" class="relative">
                      <!-- Main Image -->
                      <img :src="item.image[0]" :alt="item.title"
                        class="object-cover w-full h-56 transition-transform duration-300 cursor-pointer hover:scale-105"
                        @click.prevent="openImageModal(item)" />

                      <!-- Image Count Badge -->
                      <div v-if="item.image.length > 1"
                        class="absolute flex items-center gap-1 px-2 py-1 text-xs font-medium text-white rounded-full top-3 right-3 bg-black/70">
                        <i class="fa-solid fa-images"></i>
                        <span>{{ item.image.length }}</span>
                      </div>

                      <!-- Gallery Indicators -->
                      <div v-if="item.image.length > 1" class="absolute transform -translate-x-1/2 bottom-3 left-1/2">
                        <div class="flex space-x-1">
                          <div v-for="(img, index) in Math.min(item.image.length, 5)" :key="index"
                            class="w-2 h-2 transition-all duration-200 rounded-full"
                            :class="index === 0 ? 'bg-white' : 'bg-white/50'">
                          </div>
                          <div v-if="item.image.length > 5" class="w-2 h-2 rounded-full bg-white/30">
                          </div>
                        </div>
                      </div>

                      <!-- Hover Preview Grid -->
                      <div
                        class="absolute inset-0 flex items-center justify-center p-4 transition-opacity duration-300 opacity-0 bg-black/80 group-hover:opacity-100">
                        <div class="grid max-w-full max-h-full grid-cols-2 gap-1">
                          <div v-for="(img, index) in item.image.slice(0, 4)" :key="index"
                            class="relative overflow-hidden rounded aspect-square">
                            <img :src="img" :alt="`${item.title} - Image ${index + 1}`"
                              class="object-cover w-full h-full transition-transform duration-200 hover:scale-105" />
                            <!-- Show "+" overlay for more images -->
                            <div v-if="index === 3 && item.image.length > 4"
                              class="absolute inset-0 flex items-center justify-center text-lg font-bold text-white bg-black/60 backdrop-blur-sm">
                              +{{ item.image.length - 4 }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- No Image Placeholder -->
                    <div v-else class="flex items-center justify-center w-full h-56 text-gray-500 bg-gray-200">
                      <i class="text-3xl fa-solid fa-image"></i>
                    </div>
                    </Link>
                  </div>
                  <div class="flex flex-col flex-grow">
                    <h4 class="flex-shrink-0">
                      <Link :href="`/read/${item.slug}`" class="block text-dark font-bold text-xl mb-3.5 mobile-font">
                      <span
                        class="bg-linear-to-r from-primary/50 to-primary/40 bg-[length:0px_10px] bg-left-bottom bg-no-repeat transition-[background-size] duration-500 hover:bg-[length:100%_3px] group-hover:bg-[length:100%_10px]">
                        {{ item.title }}
                      </span>
                      </Link>
                    </h4>
                    <p class="flex-grow text-sm text-gray-600 news-content line-clamp-3 mobile-font" v-html="item.content && item.content.length > 100
                      ? item.content.substring(0, 100) + '...'
                      : item.content || ''
                      "></p>
                    <div class="flex flex-wrap items-center justify-between flex-shrink-0 gap-3 mt-4">
                      <div class="flex items-center gap-2.5">
                        <div class="flex items-center gap-3">
                          <!-- <div class="flex w-6 h-6 overflow-hidden rounded-full">
                          <img
                            :src="`/images/user/${item.author
                              .replace(/\s+/g, '-')
                              .toLowerCase()}.png`"
                            :alt="item.author"
                          />
                        </div> -->
                          <p class="text-sm">{{ item.author }}</p>
                        </div>

                        <span class="flex w-[3px] h-[3px] rounded-full bg-dark-2"></span>

                        <p class="text-sm">
                          {{ formatTanggal(item.publish_date) }}
                        </p>

                        <span class="flex w-[3px] h-[3px] rounded-full bg-dark-2"></span>

                        <!-- View Count -->
                        <div class="flex items-center gap-1 text-sm text-gray-500">
                          <i class="fa-solid fa-eye"></i>
                          <span>{{ item.formatted_view_count || '0' }}</span>
                        </div>
                      </div>
                      <span class="px-3 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-full">{{ item.tags ?
                        item.tags.join(", ") : "" }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <!-- Pagination -->
            <div class="flex justify-center mt-8">
              <button v-for="p in totalPages" :key="p" @click="goToPage(p)" :class="[
                'px-3 py-2 border border-gray-300 text-sm mx-1 rounded',
                p === page
                  ? 'bg-red-900 text-white border-red-900'
                  : 'bg-white text-gray-700 hover:bg-red-50 hover:border-red-200 hover:text-red-900',
              ]">
                {{ p }}
              </button>
            </div>
          </div>
        </section>

        <!-- Empty state when no news -->
        <section v-else>
          <div class="max-w-[1170px] mx-auto px-4 sm:px-8 xl:px-0">
            <div class="max-w-[770px] mx-auto w-full text-center mb-12.5">
              <div class="relative mb-4 text-sm text-gray-800">
                <div class="absolute top-0 bottom-0 left-0 flex items-center pl-2 text-gray-500 pointer-events-none">
                  <MagnifyingGlassVue />
                </div>
                <input v-model="search" type="text" autocomplete="off" placeholder="Cari berita..." id="search"
                  class="block w-full py-2 pl-10 text-gray-900 border-0 rounded-lg ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
              </div>
            </div>

            <div class="flex flex-col items-center justify-center py-12 text-center">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                class="w-16 h-16 mb-4 text-gray-400">
                <path fill-rule="evenodd"
                  d="M4.125 3C3.089 3 2.25 3.84 2.25 4.875V18a3 3 0 0 0 3 3h15a3 3 0 0 1-3-3V4.875C17.25 3.839 16.41 3 15.375 3H4.125ZM12 9.75a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H12Zm-.75-2.25a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75ZM6 12.75a.75.75 0 0 0 0 1.5h7.5a.75.75 0 0 0 0-1.5H6Zm-.75 3.75a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75ZM6 6.75a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-3A.75.75 0 0 0 9 6.75H6Z"
                  clip-rule="evenodd" />
                <path d="M18.75 6.75h1.875c.621 0 1.125.504 1.125 1.125V18a1.5 1.5 0 0 1-3 0V6.75Z" />
              </svg>
              <h3 class="mb-2 text-lg font-semibold text-gray-900">
                Berita tidak ditemukan
              </h3>
              <p class="text-gray-500">
                {{
                  search
                    ? `Tidak ditemukan berita yang sesuai dengan pencarian "${search}".`
                    : "Belum ada berita yang tersedia saat ini."
                }}
              </p>
            </div>
          </div>
        </section>
      </main>

      <!-- Image Gallery Modal -->
      <div v-if="imageModal.show" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
        @click="closeImageModal">
        <div class="relative max-w-4xl mx-4 overflow-hidden bg-white rounded-lg" @click.stop>
          <!-- Modal Header -->
          <div class="flex items-center justify-between p-4 border-b bg-gray-50">
            <div>
              <h3 class="text-lg font-semibold text-gray-900">{{ imageModal.title }}</h3>
              <p class="text-sm text-gray-600">{{ imageModal.images.length }} gambar</p>
            </div>
            <button @click="closeImageModal" class="text-gray-400 transition-colors hover:text-gray-600">
              <i class="text-xl fa-solid fa-times"></i>
            </button>
          </div>

          <!-- Image Display -->
          <div class="p-4">
            <!-- Current Image -->
            <div class="mb-4">
              <img :src="imageModal.images[imageModal.currentIndex]" :alt="`Gambar ${imageModal.currentIndex + 1}`"
                class="object-contain w-full rounded-lg max-h-96">
            </div>

            <!-- Navigation Buttons (if multiple images) -->
            <div v-if="imageModal.images.length > 1" class="flex items-center justify-between mb-4">
              <button @click="previousImage" :disabled="imageModal.currentIndex === 0"
                class="px-3 py-2 transition-colors bg-gray-100 rounded-lg hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed">
                <i class="mr-1 fa-solid fa-chevron-left"></i>
                Sebelumnya
              </button>
              <span class="text-sm text-gray-600">
                {{ imageModal.currentIndex + 1 }} / {{ imageModal.images.length }}
              </span>
              <button @click="nextImage" :disabled="imageModal.currentIndex === imageModal.images.length - 1"
                class="px-3 py-2 transition-colors bg-gray-100 rounded-lg hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed">
                Selanjutnya
                <i class="ml-1 fa-solid fa-chevron-right"></i>
              </button>
            </div>

            <!-- Thumbnail Strip (if multiple images) -->
            <div v-if="imageModal.images.length > 1" class="flex pb-2 space-x-2 overflow-x-auto">
              <button v-for="(img, index) in imageModal.images" :key="index" @click="imageModal.currentIndex = index"
                :class="[
                  'flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden border-2 transition-all',
                  imageModal.currentIndex === index ? 'border-indigo-500' : 'border-gray-200 hover:border-gray-300'
                ]">
                <img :src="img" :alt="`Thumbnail ${index + 1}`" class="object-cover w-full h-full">
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <FooterFe />
    </template>
  </Container>
</template>

<script setup>
import { defineProps, ref, computed, watch, onMounted, onUnmounted } from "vue";
import { Link } from "@inertiajs/vue3";
import Container from "@/Layouts/Container.vue";
import HeaderFe from "@/Components/HeaderFe.vue";
import FooterFe from "@/Components/FooterFe.vue";
import MagnifyingGlassVue from "@/Components/MagnifyingGlass.vue";
import dayjs from "dayjs";
import "dayjs/locale/id";
dayjs.locale("id");

const props = defineProps({
  newsall: {
    type: [Object, Array],
    required: true,
    default: () => [],
  },
});

const search = ref("");
const page = ref(1);
const perPage = 6; // Show 6 items per page to match the grid

// Image Modal State
const imageModal = ref({
  show: false,
  images: [],
  currentIndex: 0,
  title: ''
});

const formatTanggal = (tanggal) => {
  return tanggal ? dayjs(tanggal).format("D MMMM YYYY") : null;
};

// Client-side filtering
const filteredNews = computed(() => {
  // Handle different data structures
  let data = [];

  if (Array.isArray(props.newsall)) {
    data = props.newsall;
  } else if (props.newsall && Array.isArray(props.newsall.data)) {
    data = props.newsall.data;
  } else if (props.newsall && props.newsall.data) {
    // Handle case where data might be an object or collection
    if (Array.isArray(props.newsall.data)) {
      data = props.newsall.data;
    } else {
      data = Object.values(props.newsall.data);
    }
  } else {
    return [];
  }

  if (!search.value || search.value.trim() === "") {
    return data;
  }

  const q = search.value.toLowerCase().trim();

  return data.filter((item) => {
    if (!item) return false;

    // Search in title
    const titleMatch =
      item.title &&
      typeof item.title === "string" &&
      item.title.toLowerCase().includes(q);

    // Search in content (strip HTML tags for better search)
    const contentMatch =
      item.content &&
      typeof item.content === "string" &&
      item.content
        .replace(/<[^>]*>/g, "")
        .toLowerCase()
        .includes(q);

    // Search in author
    const authorMatch =
      item.author &&
      typeof item.author === "string" &&
      item.author.toLowerCase().includes(q);

    // Search in tags
    const tagsMatch =
      item.tags &&
      Array.isArray(item.tags) &&
      item.tags.some(
        (tag) => tag && typeof tag === "string" && tag.toLowerCase().includes(q)
      );

    return titleMatch || contentMatch || authorMatch || tagsMatch;
  });
});

// Client-side pagination
const paginatedNews = computed(() => {
  const start = (page.value - 1) * perPage;
  return filteredNews.value.slice(start, start + perPage);
});

const totalPages = computed(() =>
  Math.ceil(filteredNews.value.length / perPage)
);

function goToPage(p) {
  page.value = p;
}

// Reset page when search changes
watch(search, () => {
  page.value = 1;
});

// Image Modal Functions
const openImageModal = (newsItem) => {
  let images = [];

  if (Array.isArray(newsItem.image)) {
    images = newsItem.image;
  } else if (newsItem.image) {
    images = [newsItem.image];
  }

  if (images.length > 0) {
    imageModal.value = {
      show: true,
      images: images,
      currentIndex: 0,
      title: newsItem.title
    };
  }
};

const closeImageModal = () => {
  imageModal.value = {
    show: false,
    images: [],
    currentIndex: 0,
    title: ''
  };
};

const nextImage = () => {
  if (imageModal.value.currentIndex < imageModal.value.images.length - 1) {
    imageModal.value.currentIndex++;
  }
};

const previousImage = () => {
  if (imageModal.value.currentIndex > 0) {
    imageModal.value.currentIndex--;
  }
};

// Keyboard navigation for modal
const handleKeyDown = (event) => {
  if (!imageModal.value.show) return;

  if (event.key === 'Escape') {
    closeImageModal();
  } else if (event.key === 'ArrowRight') {
    nextImage();
  } else if (event.key === 'ArrowLeft') {
    previousImage();
  }
};

onMounted(() => {
  // Add keyboard event listener
  document.addEventListener('keydown', handleKeyDown);
});

// Cleanup event listener
onUnmounted(() => {
  document.removeEventListener('keydown', handleKeyDown);
});
</script>

<style scoped>
/* Fix for consistent card heights and prevent layout issues */
.grid {
  align-items: stretch;
}

/* Prevent content from breaking layout */
.news-content {
  overflow: hidden;
  word-break: break-word;
  hyphens: auto;
}

/* Line clamp utility for consistent text truncation */
.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* Mobile-specific font styling */
.mobile-font {
  /* Mobile font (default) */
  font-family: "Roboto Slab", "Inter", -apple-system, BlinkMacSystemFont,
    "Segoe UI", "Roboto", sans-serif;
  font-weight: bold;
}

/* Desktop font styling */
@media (min-width: 640px) {
  .mobile-font {
    font-family: "Roboto Slab", "Roboto", "Segoe UI", -apple-system,
      BlinkMacSystemFont, sans-serif;
    font-weight: inherit;
  }
}

/* Support for Quill editor classes from backend */
.news-content :deep(.ql-align-justify) {
  text-align: justify;
}

.news-content :deep(.ql-align-center) {
  text-align: center;
}

.news-content :deep(.ql-align-right) {
  text-align: right;
}

.news-content :deep(.ql-align-left) {
  text-align: left;
}

/* Custom styles for HTML content - scoped only to news-content */
.news-content :deep(ol) {
  list-style-type: decimal;
  padding-left: 1.5rem;
  margin: 0.5rem 0;
}

.news-content :deep(ul) {
  list-style-type: disc;
  padding-left: 1.5rem;
  margin: 0.5rem 0;
}

.news-content :deep(ol li),
.news-content :deep(ul li) {
  margin-bottom: 0.5rem;
  line-height: 1.5;
  padding-left: 0.25rem;
}

.news-content :deep(ol li strong),
.news-content :deep(ul li strong) {
  font-weight: 600;
  color: #1f2937;
}

/* Typography for paragraphs */
.news-content :deep(p) {
  margin: 0.5rem 0;
  line-height: 1.6;
  color: #374151;
}

/* Image responsiveness in content - hide in preview to prevent layout issues */
.news-content :deep(img) {
  display: none !important;
}

/* Ensure images don't overflow in small containers - hide in preview */
.news-content :deep(figure) {
  display: none !important;
}

/* Simplify content in preview */
.news-content :deep(h1),
.news-content :deep(h2),
.news-content :deep(h3),
.news-content :deep(h4),
.news-content :deep(h5),
.news-content :deep(h6) {
  display: none;
}

.news-content :deep(br) {
  display: none;
}

/* Hide lists in preview to maintain clean layout */
.news-content :deep(ol),
.news-content :deep(ul) {
  display: none;
}

/* Clean paragraph styling for preview */
.news-content :deep(p) {
  margin: 0;
  line-height: 1.5;
  color: #374151;
}

/* Support for other Quill formatting */
.news-content :deep(strong) {
  font-weight: 600;
}

.news-content :deep(em) {
  font-style: italic;
}

.news-content :deep(u) {
  text-decoration: underline;
}

/* Gallery styles */
.gallery-preview {
  backdrop-filter: blur(2px);
}

.gallery-counter {
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.gallery-indicators {
  backdrop-filter: blur(4px);
}

/* Image hover effects */
.cursor-pointer img {
  transition: all 0.2s ease;
}

.cursor-pointer:hover img {
  transform: scale(1.05);
}

/* Modal animations */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

/* Scrollbar styling for thumbnail strip */
.overflow-x-auto::-webkit-scrollbar {
  height: 4px;
}

.overflow-x-auto::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 2px;
}

.overflow-x-auto::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.overflow-x-auto::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Gallery preview grid responsive */
@media (max-width: 640px) {
  .gallery-preview .grid {
    grid-template-columns: 1fr 1fr;
    gap: 0.25rem;
  }
}
</style>
